import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/setup-landing-pages', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/setup-landing-pages', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getLandingPageType = (Options = {}) => {
  return httpClient
    .get('/api/setup-landing-pages/landing-page-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/setup-landing-pages/upload-photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const imageContent = data => {
  return httpClient
    .post('/api/setup-landing-pages/content-images', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/setup-landing-pages/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  getLandingPageType,
  uploadPhoto,
  destroy,
  imageContent
}
